module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/chekiwart-avatar-516bb91c298b854de828d6c90ba51295.jpg";